/* Device ValueSets and constants */

export const DEVICES = [
  {
    name: 'RxBox',
    cover: '/static/devices/RxBox.png',
  },
  {
    name: 'myBESHIE',
    cover: '/static/devices/myBESHIE.png',
  },
  {
    name: 'Echo on Sight',
    cover: '/static/devices/EOS.png',
  },
  {
    name: 'ESteth',
    cover: '/static/devices/ESteth.png',
  },
  {
    name: 'Lifeline Monitor',
    cover: '/static/devices/LifelineMonitor.png',
  },
  {
    name: 'Fetal Monitor',
    cover: '/static/devices/FetalMonitor.jpeg',
  },
  {
    name: 'Other',
    cover: '/static/icons/positive.svg',
  },
];

export const DEVICE_NAME_TYPE = {
  definingURL: 'http://hl7.org/fhir/ValueSet/device-nametype',
  version: '4.0.1',
  name: 'DeviceNameType',
  title: 'Device Name Type',
  definition: 'The type of name the device is referred by.',
  values: [
    {
      code: 'udi-label-name',
      display: 'UDI Label name',
      definition: 'UDI Label name.',
    },
    {
      code: 'user-friendly-name',
      display: 'User Friendly name',
      definition: 'User Friendly name.',
    },
    {
      code: 'patient-reported-name',
      display: 'Patient Reported name',
      definition: 'Patient Reported name.',
    },
    {
      code: 'manufacturer-name',
      display: 'Manufacturer name',
      definition: 'Manufacturer name.',
    },
    {
      code: 'model-name',
      display: 'Model name',
      definition: 'Model name.',
    },
    {
      code: 'other',
      display: 'Other',
      definition: 'Other.',
    },
  ],
};

export const DEVICE_TEMPLATE = {
  RxBox: {
    status: 'active',
    manufacturer: 'UP SITAW',
    deviceName_name: 'RxBox-',
    deviceName_type: 'manufacturer-name',
    type: 'RxBox',
  },
  myBESHIE: {
    status: 'active',
    manufacturer: 'UP SITAW',
    deviceName_name: 'myBESHIE-',
    deviceName_type: 'manufacturer-name',
    type: 'myBESHIE',
  },
  'Echo on Sight': {
    status: 'active',
    manufacturer: 'UP SITAW',
    deviceName_name: 'EOS-',
    deviceName_type: 'manufacturer-name',
    type: 'Echo on Sight',
  },
  ESteth: {
    status: 'active',
    manufacturer: 'UP SITAW',
    deviceName_name: 'ESteth-',
    deviceName_type: 'manufacturer-name',
    type: 'ESteth',
  },
  'Lifeline Monitor': {
    status: 'active',
    manufacturer: 'UP SITAW',
    deviceName_name: 'LifelineMonitor-',
    deviceName_type: 'manufacturer-name',
    type: 'Lifeline Monitor',
  },
  'Fetal Monitor': {
    status: 'active',
    manufacturer: 'UP SITAW',
    deviceName_name: 'FetalMonitor-',
    deviceName_type: 'manufacturer-name',
    type: 'Fetal Monitor',
  },
  Other: {
    status: '',
    manufacturer: '',
    deviceName_name: '',
    deviceName_type: '',
    type: '',
  },
};

export const STATUS = {
  definingURL: 'http://hl7.org/fhir/ValueSet/device-status',
  version: '4.0.1',
  name: 'FHIRDeviceStatus',
  title: 'FHIR Device Status',
  definition: 'The availability status of the device.',
  values: [
    {
      code: 'active',
      display: 'Active',
      definition:
        'The device is available for use.Note: For *implanted devices* this means that the device is implanted in the patient.',
    },
    {
      code: 'inactive',
      display: 'Inactive',
      definition:
        'The device is no longer available for use (e.g. lost, expired, damaged). Note: For *implanted devices* this means that the device has been removed from the patient.',
    },
    {
      code: 'entered-in-error',
      display: 'Entered in Error',
      definition: 'The device was entered in error and voided.',
    },
    {
      code: 'unknown',
      display: 'Unknown',
      definition: 'The status of the device has not been determined.',
    },
  ],
};

export const STATUS_REASON = {
  definingURL: 'http://hl7.org/fhir/ValueSet/device-status-reason',
  version: '4.0.1',
  name: 'FHIRDeviceStatusReason',
  title: 'FHIR Device Status Reason',
  definition: 'The availability status reason of the device.',
  values: [
    {
      code: 'online',
      display: 'Online',
      definition: 'The device is off.',
    },
    {
      code: 'paused',
      display: 'Paused',
      definition: 'The device is paused.',
    },
    {
      code: 'standby',
      display: 'Standby',
      definition: 'The device is ready but not actively operating.',
    },
    {
      code: 'offline',
      display: 'Offline',
      definition: 'The device is offline.',
    },
    {
      code: 'not-ready',
      display: 'Not Ready',
      definition: 'The device is not ready.',
    },
    {
      code: 'transduc-discon',
      display: 'Transducer Disconnected',
      definition: 'The device transducer is disconnected.',
    },
    {
      code: 'hw-discon',
      display: 'Hardware Disconnected',
      definition: 'The device hardware is disconnected.',
    },
    {
      code: 'off',
      display: 'Off',
      definition: 'The device is off.',
    },
  ],
};

export const TELEPRESENCE_MARKER_COLORS = [
  '#3D9970',
  '#0074D9',
  '#FF4136',
  '#B10DC9',
  '#85144b',
  '#7FDBFF',
  '#2ECC40',
  '#FFDC00',
  '#AAAAAA',
  '#001f3f',
];
